import React from 'react';
import StayknowNewContent from '../function-components/StayknowNewContent';

function Awards() {
  return (
      <>
        <StayknowNewContent />
      </>
  )
}

export default Awards;